import { faPodcast } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { stat } from "fs";
import * as React from "react";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import { showAlert } from "../../common/functions";
import VideoHotlineCategoryList from "./videoHotlineCategoryList";

class VideoHotlineCategoryPageComponent extends React.Component {
  state = {
    isView: false,
    selectedId: false,
    page: "",
    id: 0,
    title: "",
  };
  constructor(props: any) {
    super(props);
    var tokenstr = (new URLSearchParams(window.location.search)).get("page");
    let tValue = tokenstr === null ? "" : tokenstr
    var idstr = (new URLSearchParams(window.location.search)).get("id");
    var id = idstr === null ? 0 : parseInt(idstr);
    this.state = {
      isView: false,
      selectedId: false,
      page: tValue,
      id: id,
      title: "Add New Categories",
    }
    this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
  }

  componentDidMount() {
    var tokenstr = (new URLSearchParams(window.location.search)).get("page");
    let tValue = tokenstr === null ? "" : tokenstr
    var idstr = (new URLSearchParams(window.location.search)).get("id");
    var idChannelstr = localStorage.getItem("channelId");
    var channelId = idChannelstr === null ? 0 : parseInt(JSON.parse(idChannelstr));
    var id = idstr === null ? 0 : parseInt(idstr);
    var pageValue = id === 0 ? tValue : "detail";
    this.setState({
      ...stat,
      page: pageValue,
      id: id,
      title: "",
      isView: pageValue === "" ? true : false,
      channelId: channelId
    });

    var alertMessage = window.localStorage.getItem("alertMessage");
    if (alertMessage && alertMessage !== "") {
      showAlert(alertMessage, false);
      window.localStorage.setItem('alertMessage', "");
    }

    document.title = `${pageValue === "" ? "Video Hotline category" : "Video Hotline category"
      } - Daily Audio Bible Administration`;
  }

  handleCallbackMethod(value) {
    this.setState({ title: value });
  }

  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col lg="12">
              {this.state.page == "" && this.state.isView && (
                <div>
                  <h2>
                    <FontAwesomeIcon icon={faPodcast} />
                    <span data-testid="manageCategoryPlatformPageTitle"> Video Hotline category</span>
                  </h2>
                  <hr />
                </div>
              )}
              <VideoHotlineCategoryList />
            </Col>
            <Col />
          </Row>
        </Container>
      </div>
    );
  }
}

export default VideoHotlineCategoryPageComponent;
